import React, { Suspense } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { Loader } from 'lucide-react';

/**
 * Lazy-loaded section component that only renders when in viewport
 * 
 * @param {React.Component} children - Component to lazy load
 * @param {React.Component} fallback - Loading fallback component
 * @param {Object} options - Intersection Observer options
 */
export default function LazySection({ 
  children, 
  fallback = null,
  options = { threshold: 0.1, rootMargin: '100px' }
}) {
  const [ref, isIntersecting, hasIntersected] = useIntersectionObserver(options);

  const defaultFallback = (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: '2rem',
      minHeight: '200px'
    }}>
      <Loader size={24} className="animate-spin" style={{ marginRight: '0.5rem' }} />
      <span>Loading...</span>
    </div>
  );

  return (
    <div ref={ref}>
      {hasIntersected ? (
        <Suspense fallback={fallback || defaultFallback}>
          {children}
        </Suspense>
      ) : (
        <div style={{ minHeight: '200px' }} />
      )}
    </div>
  );
}

